window.jQuery = jQuery;
window.$ = jQuery;

export default null;
